var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { createContext, useContext } from 'react';
import { useTableTools, } from './tableTools';
var TableToolsContext = createContext({
    currentLayout: [],
    visibleColumns: [],
    totalItems: 0,
    columns: [],
    checkedItems: [],
    selectAllCheckboxState: 'none',
    currentSort: { direction: 'asc', fieldKey: '' },
    lastChecked: null,
    switchColumns: function () { },
    switchCurrentLayout: function () { },
    offsetColumns: function () { return []; },
    onSelection: function () { },
    deselectAll: function () { },
    selectAll: function () { },
    checkboxToggle: function () { },
    checkboxShiftToggle: function () { },
    checkboxState: function () { return false; },
    clientSortMethod: function () { return 0; },
    changeSortDirection: function () { },
    toggleSortDirection: function () { },
    toggleSortByKey: function () { },
    sortData: function () { },
    activeSort: function () { return false; },
    activeSortKey: function () { return false; },
    getCheckboxProps: function () { },
});
export var TableTools = function (_a) {
    var children = _a.children, stateReducer = _a.stateReducer, rest = __rest(_a, ["children", "stateReducer"]);
    var utils = useTableTools(rest, stateReducer);
    var ui = typeof children === 'function' ? children(utils) : children;
    return (React.createElement(TableToolsContext.Provider, { value: utils }, ui));
};
export var useTableToolsContext = function () {
    var utils = useContext(TableToolsContext);
    return utils;
};
//# sourceMappingURL=context.js.map